<template>
  <div class="min-h-screen w-full h-full flex flex-col">
    <div class="flex h-screen w-full bg-gray-100 flex-1">
      <!-- 路由加载指示器 -->
      <div v-show="isRouteLoading" class="route-loading-indicator">
        <div class="spinner"></div>
      </div>
      
      <!-- Mobile sidebar -->
      <div v-show="sidebarOpen" class="fixed inset-0 flex z-40 md:hidden">
        <div @click="sidebarOpen = false" class="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true"></div>

        <div class="relative flex-1 flex flex-col max-w-xs w-full tax-sidebar">
          <div class="absolute top-0 right-0 -mr-12 pt-2">
            <button @click="sidebarOpen = false" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#1aaa55]">
              <span class="sr-only">Close sidebar</span>
              <i class="fas fa-times text-white"></i>
            </button>
          </div>

          <div class="flex-1 h-0 pt-3 pb-4 overflow-y-auto">
            <div class="flex-shrink-0 flex items-center px-4 pb-3">
              <div class="flex items-center">
                <img src="https://placehold.co/120x40?text=Game-Backend" alt="Logo" class="h-10">
              </div>
            </div>

            <nav class="mt-4">
              <div class="category-header">Home</div>
              <router-link to="/admin/dashboard" class="menu-item" :class="{ 'active': isRouteActive('dashboard') }">
                <i class="fas fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </router-link>

              <div class="category-header">业务管理</div>

              <!-- 注单管理菜单 -->
              <div>
                <div @click="betMenuOpen = !betMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('bets') }">
                  <div>
                    <i class="fas fa-file-invoice"></i>
                    <span>注单管理</span>
                  </div>
                  <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': betMenuOpen}"></i>
                </div>
                <div v-show="betMenuOpen" class="submenu">
                  <router-link to="/admin/bets" class="submenu-item" :class="{ 'active': isRouteExact('bets') }">注单列表</router-link>
                  <router-link to="/admin/bets/anomaly" class="submenu-item" :class="{ 'active': isRouteExact('bets/anomaly') }">异常注单</router-link>
                  <router-link to="/admin/bets/reports" class="submenu-item" :class="{ 'active': isRouteExact('bets/reports') }">注单报表</router-link>
                  <router-link to="/admin/bets/comparison" class="submenu-item" :class="{ 'active': isRouteExact('bets/comparison') }">注单对比</router-link>
                </div>
              </div>

              <!-- 玩家管理菜单 -->
              <div>
                <div @click="playerMenuOpen = !playerMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('players') }">
                  <div>
                    <i class="fas fa-users"></i>
                    <span>玩家管理</span>
                  </div>
                  <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': playerMenuOpen}"></i>
                </div>
                <div v-show="playerMenuOpen" class="submenu">
                  <router-link to="/admin/players" class="submenu-item" :class="{ 'active': isRouteExact('players') }">玩家列表</router-link>
                  <router-link to="/admin/players/balance-logs" class="submenu-item" :class="{ 'active': isRouteExact('players/balance-logs') }">余额变动记录</router-link>
                </div>
              </div>

              <div class="category-header">系统设置</div>

              <!-- 系统管理菜单 -->
              <div>
                <div @click="systemMenuOpen = !systemMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('system') }">
                  <div>
                    <i class="fas fa-cogs"></i>
                    <span>系统管理</span>
                  </div>
                  <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': systemMenuOpen}"></i>
                </div>
                <div v-show="systemMenuOpen" class="submenu">
                  <router-link to="/admin/system/vendor-callbacks" class="submenu-item" :class="{ 'active': isRouteExact('system/vendor-callbacks') }">厂商回调</router-link>
                  <router-link to="/admin/system/performance" class="submenu-item" :class="{ 'active': isRouteExact('system/performance') }">性能监控</router-link>
                  <router-link to="/admin/system/alerts" class="submenu-item" :class="{ 'active': isRouteExact('system/alerts') }">系统报警</router-link>
                  <router-link to="/admin/system/logs" class="submenu-item" :class="{ 'active': isRouteExact('system/logs') }">系统日志</router-link>
                </div>
              </div>

              <div class="border-t border-gray-200 my-4 mx-4"></div>

              <a href="#" @click.prevent="logout" class="menu-item text-red-600 hover:bg-red-50 hover:text-red-700">
                <i class="fas fa-sign-out-alt"></i>
                <span>退出登录</span>
              </a>
            </nav>
          </div>
        </div>

        <div class="flex-shrink-0 w-14" aria-hidden="true">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </div>

      <!-- Desktop sidebar -->
      <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-64">
          <div class="flex flex-col h-0 flex-1 tax-sidebar">
            <div class="flex-1 flex flex-col pt-3 pb-4 overflow-y-auto">
              <div class="flex-shrink-0 flex items-center px-4 pb-3">
                <div class="flex items-center">
                  <img src="https://placehold.co/120x40?text=Game-Backend" alt="Logo" class="h-10">
                </div>
              </div>

              <nav class="mt-4">
                <div class="category-header">Home</div>
                <router-link to="/admin/dashboard" class="menu-item" :class="{ 'active': isRouteActive('dashboard') }">
                  <i class="fas fa-tachometer-alt"></i>
                  <span>Dashboard</span>
                </router-link>

                <div class="category-header">业务管理</div>

                <!-- 注单管理菜单 -->
                <div>
                  <div @click="betMenuOpen = !betMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('bets') }">
                    <div>
                      <i class="fas fa-file-invoice"></i>
                      <span>注单管理</span>
                    </div>
                    <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': betMenuOpen}"></i>
                  </div>
                  <div v-show="betMenuOpen" class="submenu">
                    <router-link to="/admin/bets" class="submenu-item" :class="{ 'active': isRouteExact('bets') }">注单列表</router-link>
                    <router-link to="/admin/bets/anomaly" class="submenu-item" :class="{ 'active': isRouteExact('bets/anomaly') }">异常注单</router-link>
                    <router-link to="/admin/bets/reports" class="submenu-item" :class="{ 'active': isRouteExact('bets/reports') }">注单报表</router-link>
                    <router-link to="/admin/bets/comparison" class="submenu-item" :class="{ 'active': isRouteExact('bets/comparison') }">注单对比</router-link>
                  </div>
                </div>

                <!-- 玩家管理菜单 -->
                <div>
                  <div @click="playerMenuOpen = !playerMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('players') }">
                    <div>
                      <i class="fas fa-users"></i>
                      <span>玩家管理</span>
                    </div>
                    <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': playerMenuOpen}"></i>
                  </div>
                  <div v-show="playerMenuOpen" class="submenu">
                    <router-link to="/admin/players" class="submenu-item" :class="{ 'active': isRouteExact('players') }">玩家列表</router-link>
                    <router-link to="/admin/players/balance-logs" class="submenu-item" :class="{ 'active': isRouteExact('players/balance-logs') }">余额变动记录</router-link>
                  </div>
                </div>

                <div class="category-header">系统设置</div>

                <!-- 系统管理菜单 -->
                <div>
                  <div @click="systemMenuOpen = !systemMenuOpen" class="menu-item cursor-pointer flex justify-between" :class="{ 'active': isRouteActive('system') }">
                    <div>
                      <i class="fas fa-cogs"></i>
                      <span>系统管理</span>
                    </div>
                    <i class="fas fa-chevron-right text-sm menu-arrow" :class="{'open': systemMenuOpen}"></i>
                  </div>
                  <div v-show="systemMenuOpen" class="submenu">
                    <router-link to="/admin/system/vendor-callbacks" class="submenu-item" :class="{ 'active': isRouteExact('system/vendor-callbacks') }">厂商回调</router-link>
                    <router-link to="/admin/system/performance" class="submenu-item" :class="{ 'active': isRouteExact('system/performance') }">性能监控</router-link>
                    <router-link to="/admin/system/alerts" class="submenu-item" :class="{ 'active': isRouteExact('system/alerts') }">系统报警</router-link>
                    <router-link to="/admin/system/logs" class="submenu-item" :class="{ 'active': isRouteExact('system/logs') }">系统日志</router-link>
                  </div>
                </div>

                <div class="border-t border-gray-200 my-4 mx-4"></div>

                <a href="#" @click.prevent="logout" class="menu-item-logout text-red-600 hover:bg-red-50 hover:text-red-700">
                  <i class="fas fa-sign-out-alt"></i>
                  <span>退出登录</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <!-- Top Bar -->
        <header class="h-16 tax-topbar flex items-center justify-between px-6">
          <div class="flex items-center">
            <button @click.stop="sidebarOpen = true" class="md:hidden mr-4 text-gray-500 hover:text-gray-700">
              <i class="fas fa-bars"></i>
            </button>
            <h1 class="text-gray-700 text-lg font-medium">{{ pageTitle }}</h1>
          </div>
          <div class="flex items-center">
            <button class="mr-4 text-gray-500 hover:text-gray-700">
              <i class="fas fa-bell"></i>
            </button>
            <div class="flex items-center">
              <div class="w-10 h-10 rounded-full bg-[#1aaa55] flex items-center justify-center text-white font-bold mr-2">
                {{ user.avatar }}
              </div>
              <div>
                <p class="text-gray-800 font-medium">{{ user.name }}</p>
                <p class="text-gray-500 text-xs">{{ user.role }}</p>
              </div>
            </div>
          </div>
        </header>

        <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none tax-content">
          <div class="py-6">
            <div class="w-full px-4 sm:px-6 md:px-8">
              <!-- Page content -->
              <router-view v-slot="{ Component }">
                <transition name="fade" mode="out-in">
                  <keep-alive>
                    <component :is="Component" />
                  </keep-alive>
                </transition>
              </router-view>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AdminApiClient from '../utils/admin-api-client';

// API Client
const apiClient = new AdminApiClient();

// Router
const route = useRoute();
const router = useRouter();

// Sidebar state
const sidebarOpen = ref(false);
const betMenuOpen = ref(false);
const playerMenuOpen = ref(true);
const systemMenuOpen = ref(false);

// User info
const user = ref({
  name: 'Admin User',
  role: '系统管理员',
  avatar: 'AD'
});

// Router active state helpers - Optimized for performance
const isRouteActive = (path) => {
  return route.path.includes(`/admin/${path}`);
};

const isRouteExact = (path) => {
  return route.path === `/admin/${path}`;
};

// 获取用户信息
onMounted(() => {
  const currentUser = apiClient.getCurrentUser();
  if (currentUser) {
    user.value = {
      name: currentUser.name || currentUser.username || 'Admin User',
      role: currentUser.role || '系统管理员',
      avatar: currentUser.avatar || 'AD'
    };
  }
  
  // 初始化菜单状态 - 只在挂载时计算一次
  initMenuState();
});

// 初始化菜单状态
const initMenuState = () => {
  // 使用计算属性和路由路径的预计算值，避免重复计算
  const currentPath = route.path;
  
  betMenuOpen.value = currentPath.includes('/admin/bets');
  playerMenuOpen.value = currentPath.includes('/admin/players');
  systemMenuOpen.value = currentPath.includes('/admin/system');
  
  // 添加路由变化监听器以更新菜单状态
  router.beforeEach((to, from, next) => {
    // 路由过渡开始前缓存所需数据
    document.body.classList.add('router-transition');
    
    // 优化菜单状态更新，避免不必要的DOM更新
    if (to.path.includes('/admin/bets') && !betMenuOpen.value) {
      betMenuOpen.value = true;
    } else if (!to.path.includes('/admin/bets') && betMenuOpen.value && !from.path.includes('/admin/bets')) {
      betMenuOpen.value = false;
    }
    
    if (to.path.includes('/admin/players') && !playerMenuOpen.value) {
      playerMenuOpen.value = true;
    } else if (!to.path.includes('/admin/players') && playerMenuOpen.value && !from.path.includes('/admin/players')) {
      playerMenuOpen.value = false;
    }
    
    if (to.path.includes('/admin/system') && !systemMenuOpen.value) {
      systemMenuOpen.value = true;
    } else if (!to.path.includes('/admin/system') && systemMenuOpen.value && !from.path.includes('/admin/system')) {
      systemMenuOpen.value = false;
    }
    
    next();
  });
  
  // 路由过渡结束后移除过渡类
  router.afterEach(() => {
    setTimeout(() => {
      document.body.classList.remove('router-transition');
    }, 200);
  });
};

// 路由加载状态
const isRouteLoading = ref(false);

// 设置路由加载状态监听
router.beforeResolve((to, from, next) => {
  if (to.path !== from.path) {
    isRouteLoading.value = true;
  }
  next();
});

router.afterEach(() => {
  // 延迟一小段时间再隐藏，避免闪烁
  setTimeout(() => {
    isRouteLoading.value = false;
  }, 200);
});

// Page title - 使用计算属性优化
const pageTitle = computed(() => {
  const routeNames = {
    '/admin/dashboard': 'Dashboard',
    '/admin/bets': '注单列表',
    '/admin/bets/anomaly': '异常注单',
    '/admin/bets/reports': '注单报表',
    '/admin/bets/compare': '注单对比',
    '/admin/players': '玩家列表',
    '/admin/players/balance-logs': '余额变动记录',
    '/admin/system/vendor-callback': '厂商回调',
    '/admin/system/performance': '性能监控',
    '/admin/system/alerts': '系统报警',
    '/admin/system/logs': '系统日志'
  };
  
  return routeNames[route.path] || 'Game-Backend 管理系统';
});

// Logout function
const logout = async () => {
  try {
    await apiClient.logout();
    router.push('/admin/login');
  } catch (error) {
    console.error('登出失败:', error);
    // 即使API调用失败，也要尝试重定向到登录页
    router.push('/admin/login');
  }
};
</script>

<style scoped>
/* Component-specific styles */
[x-cloak] { display: none !important; }
.tax-sidebar { 
  background-color: #fff; 
  border-right: 1px solid #e5e7eb; 
  will-change: transform;
  contain: strict;
}
.tax-topbar { 
  background-color: #fff; 
  border-bottom: 1px solid #e5e7eb; 
  will-change: transform;
  contain: layout style;
}
.tax-btn-primary { background-color: #1aaa55; color: white; }
.tax-content { 
  background-color: #f9fafc; 
  contain: content;
}

/* Category headers */
.category-header {
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  padding: 16px 16px 8px;
  text-transform: uppercase;
}

/* Menu items */
.menu-item {
  color: #4b5563;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  margin: 2px 0;
  transition: all 0.15s ease;
  contain: content;
  will-change: background-color, color;
}

.menu-item-logout{
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  margin: 2px 0;
  transition: all 0.15s ease;
  contain: content;
  will-change: background-color, color;
}

.menu-item-logout i {
  width: 24px;
  text-align: center;
  margin-right: 12px;
  font-size: 16px;
  opacity: 0.8;
}

.menu-item:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.menu-item.active {
  background-color: #e6f7ee;
  color: #1aaa55;
  font-weight: 500;
}

.menu-item i {
  width: 24px;
  text-align: center;
  margin-right: 12px;
  font-size: 16px;
  opacity: 0.8;
}

/* Submenu styles */
.submenu {
  padding-left: 36px;
  transition: height 0.2s ease-out;
  contain: content;
}

.submenu-item {
  color: #4b5563;
  display: flex;
  align-items: center;
  padding: 8px 16px 8px 48px;
  font-size: 13px;
  transition: all 0.15s ease;
  contain: content;
  will-change: background-color, color;
}

.submenu-item:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.submenu-item.active {
  color: #1aaa55;
  font-weight: 500;
}

/* Menu arrows */
.menu-arrow {
  transition: transform 0.2s;
}

.menu-arrow.open {
  transform: rotate(90deg);
}

/* Router transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 路由过渡中的全局样式 */
:global(.router-transition) * {
  transition-duration: 0ms !important;
  animation-duration: 0ms !important;
}

/* 优化GPU加速 */
router-link, a, button {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 优化过渡 */
* {
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Route loading indicator */
.route-loading-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, transparent, #1aaa55, transparent);
  z-index: 9999;
  animation: loading-bar 1.5s infinite;
  opacity: 0.8;
}

@keyframes loading-bar {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border-left-color: #1aaa55;
  animation: spin 1s linear infinite;
  position: absolute;
  right: 20px;
  top: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 